// ./src/components/layouts/SimpleLayout/SimpleLayout.tsx
import React from "react";
import { AppShell, Group, Text, Box } from "@mantine/core";
import { Logo } from "../../generic/Logo";

export interface SimpleLayoutProps {
  children: React.ReactNode;
  page?: any;
}

export const SimpleLayout: React.FC<SimpleLayoutProps> = ({
  children,
  page,
}) => {
  const { name, subtitle } = page || {};

  return (
    <AppShell header={{ height: 70 }} padding="md">
      {/* Header */}
      <AppShell.Header>
        <Group h="100%" px="md" justify="space-between">
          <Group>
            <Logo size="small" />
            {name && (
              <Box>
                <Text size="lg" fw={600} c="dark">
                  {name}
                </Text>
                {subtitle && (
                  <Text size="sm" c="dimmed">
                    {subtitle}
                  </Text>
                )}
              </Box>
            )}
          </Group>
        </Group>
      </AppShell.Header>

      {/* Main Content */}
      <AppShell.Main>{children}</AppShell.Main>
    </AppShell>
  );
};
